import { render, staticRenderFns } from "./ModalEmployee.vue?vue&type=template&id=4ffdc035"
import script from "./ModalEmployee.vue?vue&type=script&lang=js"
export * from "./ModalEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports